import React from 'react'
import './Navbar.css'

function Navbar() {
    return (
        <header className='header'>
            <nav className='navbar'>
                <a href="/">About</a>
                <a href="/skills">Skills</a>
                <a href="/projects">Projects</a>
                <a href="/writing">Writing</a>
            </nav>
        </header>
    )
}

export default Navbar